import { BlogDetailTitleElementDataType } from '@/components/sections/builder/elements/body/blog-detail/type';
import { getOverrideAnimationParams } from '@/components/sections/builder/settings/animation-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Checkbox } from '@/components/ui/checkbox';
import { useBuilderStore } from '@/stores/builder';
import { IBlogPost } from '@/types/blog';
import clsx from 'clsx';
import { format } from 'date-fns';
import { Type } from 'lucide-react';
import { shallow } from 'zustand/vanilla/shallow';

const defaultData: BlogDetailTitleElementDataType = {
  name: 'Title',
  label: 'Product A',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as BlogDetailTitleElementDataType;
  const parentData = (element.parentData || {}) as IBlogPost;
  return (
    <>
      <div className='mx-auto my-4 max-w-5xl space-y-3 text-justify'>
        <h1
          data-animation='true'
          {...getOverrideAnimationParams(data.animation)}
          className={clsx('theme_font_heading text-3xl font-bold')}
        >
          {parentData.title}
        </h1>

        <div className='flex items-center gap-x-5 pt-0 uppercase'>
          {data.showDate && (
            <span>
              {parentData.created_at ? format(new Date(parentData.created_at), 'd MMMM yyyy') : ''}
            </span>
          )}
          {data.showAuthor && (
            <div className='flex items-center space-x-2'>
              <span className='font-medium'>{parentData.author}</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export const ElementPreviewIcon = Type;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  const data = (element.data || defaultData) as BlogDetailTitleElementDataType;

  return (
    <div>
      <div className='mt-4 flex gap-x-1'>
        <Checkbox
          id='showAuthor'
          aria-label='Select'
          className='mx-2'
          checked={data.showAuthor}
          onCheckedChange={(checked) => {
            builder.setChildData(element.parentId as string, element.id, {
              showAuthor: !!checked,
            });
          }}
        />
        <label htmlFor='showAuthor'>Show author</label>
      </div>
      <div className='mt-4 flex gap-x-1'>
        <Checkbox
          id='showDate'
          aria-label='Select'
          className='mx-2'
          checked={data.showDate}
          onCheckedChange={(checked) => {
            builder.setChildData(element.parentId as string, element.id, {
              showDate: !!checked,
            });
          }}
        />
        <label htmlFor='showDate'>Show date</label>
      </div>
    </div>
  );
}

const BlogDetailTitle = {
  type: 'title',
  group: 'blog_detail',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default BlogDetailTitle;
